import { call, put, takeEvery } from "redux-saga/effects";
import * as constClass from "../../../common/constant/constantURL";
import { getCall, postCall } from "../../../helpers/fakebackend_helper";
import { HIRE_DETAILS, SAVE_HIRE_DETAILS } from "./actionTypes";
import {
  getCandidateHiringDetailsFailed,
  getCandidateHiringDetailsSuccess,
  saveHiringDetailsFalied,
  saveHiringDetailsSuccess,
} from "./actions";
// get candidate hiring details
function* getHireCandidateData({ payload: { jobId, candidateId } }) {
  try {
    const url =
      constClass.REST_API_GET_HIRE_CANDIDATE_DATA +
      `jobId=${jobId}&candidateId=${candidateId}`;
    let responsJSON = yield call(getCall, url);
    yield put(getCandidateHiringDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateHiringDetailsFailed(error));
  }
}

function* saveHireDetails({ payload: data }) {
  try {
    let url = constClass.REST_API_GET_SAVE_HIRE_CANDIDATE_DATA;
    let responsJSON = yield call(postCall, url, data.data);
    yield put(saveHiringDetailsSuccess(responsJSON.message));
  } catch (error) {
    yield put(saveHiringDetailsFalied(error));
  }
}

function* hireSaga() {
  yield takeEvery(HIRE_DETAILS, getHireCandidateData);
  yield takeEvery(SAVE_HIRE_DETAILS, saveHireDetails);
}
export default hireSaga;
